var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterIconSecondary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.12001 19.3002C8.51001 19.6902 9.14001 19.6902 9.53001 19.3002L12 16.8302L14.47 19.3002C14.86 19.6902 15.49 19.6902 15.88 19.3002C16.27 18.9102 16.27 18.2802 15.88 17.8902L12.71 14.7202C12.32 14.3302 11.69 14.3302 11.3 14.7202L8.13001 17.8902C7.73001 18.2702 7.73001 18.9102 8.12001 19.3002ZM15.88 4.70021C15.49 4.31021 14.86 4.31021 14.47 4.70021L12 7.17022L9.53001 4.70021C9.14001 4.31021 8.51001 4.31021 8.12001 4.70021C7.73001 5.09021 7.73001 5.73021 8.12001 6.12021L11.29 9.29022C11.68 9.68021 12.31 9.68021 12.7 9.29022L15.87 6.12021C16.27 5.73021 16.27 5.09021 15.88 4.70021Z",
    fill: "#F9FAFC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIconSecondary);
export default __webpack_public_path__ + "static/media/filterIconSecondary.192f9064f1c37e2ef5833b0231a14b59.svg";
export { ForwardRef as ReactComponent };